export const formSnackbar = {
  profileSuccess:{
    successMessage:'Your post has been published successfully! It is now visible to users.',
    successMessageDraft:'Your draft has been saved successfully. You can return later to edit or publish it.',
    successBrandMessage:'Brand details save successfully.',
    successEventMessage:'Event details submit successfully.',
  },
  errors: {
    errorMsg: 'Something went wrong! Your request has failed.',
  },
}
